<vi-page [sidenavs]="true" [footer]="true" [isWhiteBackground]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="booking"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="booking"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.BOOKING' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <vi-content body [centered]="true">
    <mat-horizontal-stepper main #stepper [selectedIndex]="currentStep">
      <mat-step #first_step>
        <ng-template matStepLabel>{{ '+BOOKING.STEPPER.SELECT_DEVICES' | translate }}</ng-template>
        <ng-template matStepperIcon="edit">
          <mat-icon>check</mat-icon>
        </ng-template>

        <ng-container *ngIf="stepper.selected === first_step">
          <app-booking-devices
            *ngIf="installationsStore.loaded$ | async; else loader"
            [invoiceNumber]="invoiceNumber"
            (nextPage)="nextStep(stepper)"
          ></app-booking-devices>
        </ng-container>
      </mat-step>
      <mat-step #second_step>
        <ng-template matStepLabel>{{ '+BOOKING.STEPPER.CHECKOUT' | translate }}</ng-template>
        <ng-template matStepperIcon="edit">
          <mat-icon>check</mat-icon>
        </ng-template>

        <ng-container *ngIf="stepper.selected === second_step">
          <app-booking-contingent-subscriptions-checkout
            *ngIf="
              (installationsStore.loaded$ | async) && (bookingStore.bookingViewLoaded$ | async);
              else loader
            "
            [invoiceNumber]="invoiceNumber"
            (back)="previousStep(stepper)"
          ></app-booking-contingent-subscriptions-checkout>
        </ng-container>
      </mat-step>
    </mat-horizontal-stepper>
  </vi-content>
  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>

<ng-template #loader>
  <vi-loader main data-at-loader [isLoading]="true"></vi-loader>
</ng-template>
